import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { RefreshCw } from 'lucide-react';
import { applyPwaUpdate, PWA_EVENTS } from './registerSW';

/**
 * Listens for `PWA_EVENTS.UPDATE_READY` (fired by `registerPwaServiceWorker`
 * when a new SW is waiting) and surfaces a sticky toast with a "Reload"
 * action. Mounted once at the app root.
 */
export function UpdatePrompt() {
    useEffect(() => {
        const handler = () => {
            toast.custom(
                (t) => (
                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-3 flex items-center gap-3">
                        <RefreshCw className="w-5 h-5 text-blue-600" aria-hidden />
                        <div className="text-sm">
                            <div className="font-medium text-gray-900">New version available</div>
                            <div className="text-xs text-gray-500">Reload to update.</div>
                        </div>
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                applyPwaUpdate();
                            }}
                            className="text-xs font-semibold text-blue-600 hover:text-blue-700 px-2 py-1 rounded"
                        >
                            Reload
                        </button>
                        <button
                            onClick={() => toast.dismiss(t.id)}
                            className="text-xs text-gray-400 hover:text-gray-600 px-2 py-1 rounded"
                        >
                            Later
                        </button>
                    </div>
                ),
                { duration: Infinity, position: 'bottom-right' }
            );
        };
        window.addEventListener(PWA_EVENTS.UPDATE_READY, handler);
        return () => window.removeEventListener(PWA_EVENTS.UPDATE_READY, handler);
    }, []);

    return null;
}
